import { useEffect } from "react";
import { ClientRoutes } from "../../../../Constants/ClientRoutingConstants";
import useAssetStore from "../../../../Zustand/hmeDashboardStore";

/**
 * Resets persisted Assets list filters when the user navigates away from
 * the Assets dashboard (list or asset detail). List ↔ detail keeps filters.
 *
 * Must be called from both the list page and the detail page. On unmount,
 * checks the current URL: if no longer on a dashboard route, resets filters.
 */
export function useResetAssetsDashboardFiltersOnLeave() {
  const resetAssetsListFilters = useAssetStore(
    (state) => state.resetAssetsListFilters,
  );

  useEffect(() => {
    return () => {
      const base = ClientRoutes.AssetsDashboardPage;
      const pathname = window.location.pathname;
      const stillOnAssetsDashboard =
        pathname === base || pathname.startsWith(`${base}/`);
      if (!stillOnAssetsDashboard) {
        resetAssetsListFilters();
      }
    };
  }, [resetAssetsListFilters]);
}
